import React from 'react';
import Section from './Section';

const Education = () => {
  return (
    <Section id="education" label="Education">
      <div className="flex flex-col gap-1 sm:flex-row sm:items-baseline sm:justify-between sm:gap-8">
        <h3 className="font-display text-xl font-semibold tracking-tight text-ink">
          Tufts University
        </h3>
        <p className="shrink-0 text-sm tabular-nums text-muted">Aug 2024 – May 2028</p>
      </div>
      <p className="mt-1 text-ink/85">
        B.A. Computer Science and Economics, minor in AI Development
      </p>
      <p className="mt-1 text-muted">Medford, MA</p>
      <p className="mt-4 text-ink/80">Honors: Dean’s List</p>
      <div className="mt-6">
        <h4 className="text-sm font-medium text-spruce">Relevant courses</h4>
        <p className="mt-2 max-w-prose leading-relaxed text-ink/80">
          Data Structures, Machine Structure & Assembly, Discrete Math, Linear Algebra,
          Artificial Intelligence, Machine Learning, Intermediate Microeconomics
        </p>
      </div>
    </Section>
  );
};

export default Education;
